/** @format */

import { makeStyles } from '@material-ui/core';
import React from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import InputFormRest from '../../../components/Form/InputFormRest';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import RateInterface from '../../../interfaces/billing/RateInterface';

interface RateServiceProps {
    tmp?: string;
    changeRateInput: (e: any, stateName: string) => void;
    rateEntity: RateInterface;
    rateEntityStatus: any;
}

export const RateService = (props: RateServiceProps): React.ReactElement => {
    const useStyle = makeStyles(adescomStyle);
    const classes = useStyle();

    const { changeRateInput, rateEntity, rateEntityStatus } = props;

    return (
        <GridContainer>
            <GridItem xs={9}>
                <GridContainer>
                    <GridItem xs={5}>
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="interval1"
                            stateObjectState={rateEntityStatus.interval1}
                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                            typeField={FormGeneralHelper.TYPE_NUMBER}
                            displayFieldName="pricelists:h.interval1"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.interval1}
                            step={1}
                        />
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="price1"
                            stateObjectState={rateEntityStatus.price1}
                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                            typeField={FormGeneralHelper.TYPE_NUMBER}
                            displayFieldName="pricelists:h.price1"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.price1}
                        />
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="duration1"
                            stateObjectState={rateEntityStatus.duration1}
                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                            typeField={FormGeneralHelper.TYPE_NUMBER}
                            displayFieldName="pricelists:h.duration1"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.duration1}
                            step={1}
                        />
                    </GridItem>
                    <GridItem xs={2}></GridItem>
                    <GridItem xs={5}>
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="interval2"
                            stateObjectState={rateEntityStatus.interval2}
                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                            typeField={FormGeneralHelper.TYPE_NUMBER}
                            displayFieldName="pricelists:h.interval2"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.interval2}
                            step={1}
                        />
                        <InputFormRest
                            classes={classes}
                            callback={changeRateInput}
                            stateName="price2"
                            stateObjectState={rateEntityStatus.price2}
                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                            typeField={FormGeneralHelper.TYPE_NUMBER}
                            displayFieldName="pricelists:h.price2"
                            required={false}
                            vMax={255}
                            vMin={0}
                            value={rateEntity.price2}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
